<script>
export default {
  methods: {
    processHighlightItem(highlights, num) {
      let color = ""
      if (!highlights.length) return color

      highlights.forEach(function(item) {
        if (item.operator === "gte") {
          if (num >= (item.first / 100)) {
            color = item.color
            return
          }
        } else if (item.operator === "gt") {
          if (num > (item.first / 100)) {
            color = item.color
            return
          }
        } else if (item.operator === "between") {
          if (num < (item.first / 100) && num > (item.second / 100)) {
            color = item.color
            return
          }
        } else if (item.operator === "lte") {
          if (num <= (item.first / 100)) {
            color = item.color
            return
          }
        } else if (item.operator === "lt") {
          if (num < (item.first / 100)) {
            color = item.color
            return
          }
        }
      })

      return color
    },
    setCPMHighlights(type) {
      this.input[type].highlights = {
        budget: [
          {
            key: 1,
            operator: "gte",
            first: 85,
            second: null,
            color: "green"
          },
          {
            key: 2,
            operator: "between",
            first: 85,
            second: 70,
            color: "yellow"
          },
          {
            key: 3,
            operator: "lte",
            first: 70,
            second: null,
            color: "red"
          }
        ],
        impressions: [
          {
            key: 1,
            operator: "gte",
            first: 100,
            second: null,
            color: "green"
          },
          {
            key: 2,
            operator: "between",
            first: 100,
            second: 80,
            color: "yellow"
          },
          {
            key: 3,
            operator: "lte",
            first: 80,
            second: null,
            color: "red"
          }
        ],
        media: [
          {
            key: 1,
            operator: "gte",
            first: 100,
            second: null,
            color: "red"
          },
          {
            key: 2,
            operator: "between",
            first: 100,
            second: 80,
            color: "yellow"
          },
          {
            key: 3,
            operator: "lte",
            first: 80,
            second: null,
            color: "green"
          }
        ]
      }
    },
    setAgencyHighlights(type) {
      this.input[type].highlights = {
        budget: [
          {
            key: 1,
            operator: "gte",
            first: 100,
            second: null,
            color: "red"
          },
          {
            key: 2,
            operator: "between",
            first: 100,
            second: 85,
            color: "green"
          },
          {
            key: 3,
            operator: "between",
            first: 85,
            second: 70,
            color: "yellow"
          },
          {
            key: 4,
            operator: "lte",
            first: 70,
            second: null,
            color: "yellow"
          }
        ],
        impressions: [],
        media: []
      }
    }
  }
}
</script>
